<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} thông tin</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} thông tin</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} thông tin</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <b-row>
                <b-col md="3">
                  <el-form-item label="Họ tên" prop="ho_ten.ho_ten">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.ho_ten.ho_ten"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Email" prop="email">
                    <el-input
                      v-model="mData.dataForm.email"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Giới tính" prop="gioi_tinh">
                    <el-select
                      v-model="mData.dataForm.gioi_tinh"
                      :placeholder="aLang.c_select"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listGioiTinh"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col md="3">
                  <el-form-item label="Điện thoại" prop="dien_thoai">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.dien_thoai"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                  <b-col md="3">
                      <el-form-item label="Số thẻ" prop="so_the">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.so_the"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                  </b-col>
                <b-col md="9">
                  <el-form-item label="Địa chỉ" prop="dia_chi.dia_chi">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.dia_chi.dia_chi"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import KhachDuLichModel from "./KhachDuLichModel";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import DataService from '@/service/DataService';

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      tabIndex: [0, 0],
      mData: {
        viewMode: "detail",
        moduleName: "ThongTin",
        dataDefault: {
            listGioiTinh: DataService.gioiTinh,
        },
        dataForm: MethodService.copyObject(KhachDuLichModel.dataForm),
        validForm: KhachDuLichModel.validForm,
      }
    };
  },
  methods: {
    async fn_getDataById(id) {
      let kdl = await KhachDuLichApi.findById(id);
      if (kdl.result) {
        this.mData.dataForm = kdl.result;
        if (kdl.result.mediaId) {
          let data = {
            id: kdl.result.mediaId,
            name: kdl.result.mediaId
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
      }
    },
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "update") {
            data.id = this.$router.currentRoute.params.id;
            await KhachDuLichApi.update(data);
           this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
     fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        KhachDuLichModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    },

  created: function() {
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }

  },
  mounted: function() {}
};
</script>
